import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BackgroundQualifier } from "./base/BackgroundQualifier";
/**
 * @description A class for blurred background transformations.
 * @memberOf Qualifiers.Background
 * @extends {Qualifiers.Background.BackgroundQualifier}
 */

var BlurredBackgroundAction = /*#__PURE__*/function (_BackgroundQualifier) {
  _inherits(BlurredBackgroundAction, _BackgroundQualifier);

  var _super = _createSuper(BlurredBackgroundAction);

  function BlurredBackgroundAction() {
    _classCallCheck(this, BlurredBackgroundAction);

    return _super.apply(this, arguments);
  }

  _createClass(BlurredBackgroundAction, [{
    key: "intensity",
    value:
    /**
     * @description Sets the intensity of the blur.
     * @param {number} value - The intensity of the blur.
     */
    function intensity(value) {
      this.intensityLevel = value;
      return this;
    }
    /**
     * @description Sets the brightness of the background.
     * @param {number} value - The brightness of the background.
     */

  }, {
    key: "brightness",
    value: function brightness(value) {
      this.brightnessLevel = value;
      return this;
    }
    /**
     * @description
     * Stringify the qualifier
     * BackgroundQualifiers don't have a value, but instead override the toString() function
     */

  }, {
    key: "toString",
    value: function toString() {
      // b_blurred:{intensity}:{brightness}
      return "\n    b_blurred\n    ".concat(this.intensityLevel ? ":".concat(this.intensityLevel) : '', "\n    ").concat(this.brightnessLevel ? ":".concat(this.brightnessLevel) : '', "\n    ").replace(/\s+/g, '');
    }
  }]);

  return BlurredBackgroundAction;
}(BackgroundQualifier);

export default BlurredBackgroundAction;